import React, {FC} from 'react'

const Intro: FC = () => (
    <h1>Hello</h1>
)

export default Intro
